export default {
      id: "icon-facebook-usage",
      viewBox: "0 0 31.264 31.076",
      url: __webpack_public_path__ + "img/icons.svg#icon-facebook",
      toString: function () {
        return this.url;
      }
    }